import React from "react";
import { useSpeech } from "react-text-to-speech";
import { Box, Button } from "@mui/material";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import StopCircleIcon from '@mui/icons-material/StopCircle';




const SpeechRenderer = ({ text, auto, css }: { text: string, auto?: boolean, css?: object | null }) => {
    const { speechStatus, start, stop } = useSpeech({
        text,
        pitch: 1,
        rate: 1,
        volume: 1,
        lang: "pt-BR",
        voiceURI: "Microsoft Antonio Online (Natural) - Portuguese (Brazil)",
        autoPlay: auto ? true : false,
        highlightText: false,
        showOnlyHighlightedText: false,
        highlightMode: "word",
      }) as {
        Text: React.FC;
        speechStatus: "started" | "paused" | "stopped";
        start: () => void;
        pause: () => void;
        stop: () => void;
      };

      return (
        <>
          {auto ? (
            <></>
          ) : (
            <Box sx={css ? css : {}}>
              <Button sx={{ minWidth: 0 }}disabled={speechStatus === "started"} onClick={start}>
                <PlayCircleOutlineIcon />
              </Button>
              <Button sx={{ minWidth: 0 }} disabled={speechStatus === "stopped"} onClick={stop}>
                <StopCircleIcon />
              </Button>
            </Box>
          )}
        </>
      );
};

interface SpeechClassComponentProps {
    text?: string; // `text` agora é opcional
    auto?: boolean;
    css?: object | null;
  }

class SpeechClassComponent extends React.Component<SpeechClassComponentProps> {
    render() {
      return <SpeechRenderer 
      text={this.props.text || ""} 
      auto={this.props.auto || false}
      css={this.props.css || {}}
      
      />;
    }
  }
  
  export default SpeechClassComponent;